import { TextField } from '@mui/material';
import React from 'react';
import { Control, useController } from 'react-hook-form';

export interface DescriptionFieldProps {
  control: Control<any>;
  name: string;
}

const DescriptionField = ({ control, name }: DescriptionFieldProps) => {
  const {
    field,
    fieldState: { error },
  } = useController({
    control,
    name,
    rules: {
      required: 'Please provide a description',
      validate: { whitespace: value => !!value.trim() || 'Please provide a description that is not only whitespace' },
    },
  });

  return (
    <TextField
      {...field}
      error={!!error}
      helperText={error?.message}
      inputProps={{ maxLength: 150 }}
      label="Subject"
      multiline={false}
      placeholder="Add a short description for the activity that provides an overview for you students. It should be around 150 characters long, similar to this text."
      required
      sx={{ width: '100%' }}
      id="cy-desc"
    />
  );
};

export default DescriptionField;
